import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { Eyebrow } from './Eyebrow';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="bg-paper-100 py-16 sm:py-24" data-id="element-21" data-mp="pm2eu58fzvl9">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-22" data-mp="authtb27n7y3">
        <div className="max-w-2xl" data-id="element-23" data-mp="ftefp3tzpfjd">
          <div className="flex items-center gap-3" data-id="element-24" data-mp="fsbsb5vvlv87">
            <GiftIcon className="h-4 w-4 text-brass" aria-hidden="true" data-id="element-25" data-mp="1tvi34yt1mlb" />
            <Eyebrow data-id="element-26" data-mp="5w0do98tctal">Included today at no extra cost</Eyebrow>
          </div>
          <h2 id="bonuses-heading" className="mt-5 font-display text-3xl font-semibold leading-tight text-ink sm:text-5xl" data-id="element-27" data-mp="5tvxartqa1tf">
            Five strategic bonuses
          </h2>
          <p className="mt-5 text-base text-ink-soft" data-id="element-28" data-mp="3t2j65sofjnwk">
            Real value <span className="text-ink-muted line-through" data-id="element-29" data-mp="1martlmorw830">$250</span> &mdash;{' '}
            <strong className="font-semibold text-brass-dark" data-id="element-30" data-mp="1r8a43hifuvd4">
              today completely free with the Arsenal
            </strong>
            .
          </p>
        </div>

        <ul className="mt-8 grid gap-6 sm:mt-12 sm:grid-cols-2 sm:gap-8 lg:grid-cols-3" data-id="element-31" data-mp="3dfv6j27jnjbc">
          {bonuses.map(bonus => <li key={bonus.number} className="flex flex-col border border-paper-300 bg-paper shadow-[0_1px_2px_rgba(27,24,21,0.04)]" data-id="element-32" data-mp="3r5gihsmxey9v">
              <img src={bonus.image} alt={`Cover of ${bonus.title}`} className="aspect-[4/3] w-full border-b border-paper-300 object-cover" data-id="element-33" data-mp="2zf2d6kszau9t" />
              <div className="flex flex-1 flex-col p-7" data-id="element-34" data-mp="38gil8lwbmkav">
                <div className="flex items-center justify-between gap-4" data-id="element-35" data-mp="38dw35sbt0mee">
                  <span className="text-[11px] font-semibold uppercase tracking-label text-ink-muted" data-id="element-36" data-mp="33fm9jm5q9tuw">
                    Bonus {bonus.number}
                  </span>
                  <span className="bg-brass-wash px-2 py-1 text-[10px] font-semibold uppercase tracking-label text-brass-dark" data-id="element-37" data-mp="irq4gxaxp8ef">
                    {bonus.value} &middot; Free
                  </span>
                </div>
                <h3 className="mt-5 font-display text-2xl leading-snug text-ink" data-id="element-38" data-mp="3hgg49m9z7q9i">{bonus.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-ink-soft" data-id="element-39" data-mp="3lk4de9e9atwv">{bonus.description}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}